
import React from "react";
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger, 
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { KnowledgeArticle, KnowledgeCollection } from "./types";

interface KnowledgeCollectionsListProps {
  collections: KnowledgeCollection[];
  onArticleSelect: (article: KnowledgeArticle) => void;
  isEmbedded?: boolean;
}

const KnowledgeCollectionsList = ({
  collections,
  onArticleSelect,
  isEmbedded = false
}: KnowledgeCollectionsListProps) => {
  return (
    <Accordion type="single" collapsible className="w-full">
      {collections.map((collection) => (
        <AccordionItem key={collection.id} value={collection.id}>
          <AccordionTrigger className="text-md font-medium hover:no-underline">
            {collection.name}
          </AccordionTrigger>
          <AccordionContent>
            {collection.articles.length > 0 ? (
              <ul className="space-y-1 ml-1">
                {collection.articles.map((article) => (
                  <li key={article.id}>
                    <Button
                      variant="ghost"
                      className="justify-start h-auto py-1.5 text-sm w-full text-left"
                      onClick={() => onArticleSelect(article)}
                    >
                      {article.title}
                    </Button>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-xs text-muted-foreground pl-2">
                No articles in this collection
              </p>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default KnowledgeCollectionsList;
